import { Button, GridView, Widget } from '@digital/ui';
import React, { useState, useEffect } from 'react';
import { Collapse } from 'antd';
import TableCicloOrcamentarioPluriAnual from '../Relatorios/RelatorioCicloOrcamentarioPluriAnual/TableCicloOrcamentarioPluriAnual';
import { CrfCicloOrcamentarioRelatorio } from '@app/api/crf/CrfRelatorioCicloorcamentario';
import { hasPermission } from '@app/helpers/permissions';
import { exportarCrfFechamentoPluriAnual, getCrfFechamentoPluriAnualByFechamentoId } from '@app/api/crf/crffechamento';
const { Panel } = Collapse;

interface FechamentoPluriAnualProps {
  fechamentoId: string;
}

const FechamentoPluriAnual = (props: FechamentoPluriAnualProps) => {
  const { fechamentoId } = props;

  const [cicloOrcamentarioRelatorioTotal, setCicloOrcamentarioRelatorioTotal] = useState<CrfCicloOrcamentarioRelatorio>();

  useEffect(() => {
    getCrfFechamentoPluriAnualByFechamentoId(fechamentoId).then(result => {
      setCicloOrcamentarioRelatorioTotal(result);
    });
  }, [fechamentoId]);

  const btnExportar = () => {
    if (fechamentoId && hasPermission(['FECHAMENTO_PLURI_ANUAL_BOTAO_EXPORTA_RELATORIO_VISUALIZAR'])) {
      return [
        <Button
          type="primary"
          size={'small'}
          icon="files-ms_excel"
          onClick={() => {
            exportarCrfFechamentoPluriAnual(fechamentoId, 'pluriAnualRelatorio.xlsx');
          }}>
          Exporta Relatório
        </Button>,
      ];
    }
    return [];
  };

  return (
    <GridView noform>
      <Widget title="RESULTADO" span={12} actions={btnExportar()}>
        {cicloOrcamentarioRelatorioTotal && fechamentoId ? (
          <TableCicloOrcamentarioPluriAnual
            cicloOrcamentarioRelatorioTotal={cicloOrcamentarioRelatorioTotal}
            ocultarColunaDetalhe={true}
            mostrarColunaDetalheFechamento={true}
            fechamentoId={fechamentoId}
            paginacaoConfig={{
              pageSize: 10,
              onChange: () => {
                //document.getElementById("tableCicloOrcamentarioPluriAnual").scrollIntoView();
              },
            }}
          />
        ) : (
          <></>
        )}
      </Widget>
    </GridView>
  );
};

export default FechamentoPluriAnual;
